export default "__VITE_ASSET__bfc1e6dd__"